import { Player } from '@lc/interface/player/types';

export function getActivePlayer(
	playerStateArray: Player[],
	activePlayerId: number
): Player | undefined {
	return playerStateArray.find(
		(player) => player.playerId === activePlayerId
	);
}

export function getPlayerStateWithId(
	playerStateArray: Player[],
	playerId: number
): Player | undefined {
	return playerStateArray.find((p) => p.playerId === playerId);
}

export function getColor(color: string) {
	if (color === 'yellow') {
		return '#f6de9a';
	} else if (color === 'blue') {
		return '#15bedb';
	} else if (color === 'red') {
		return '#efa1ae';
	} else if (color === 'green') {
		return '#556341';
	} else if (color === 'fail') {
		return '#fb2d01';
	}

	return '#ffffff';
}
